<template>
  <div>
    <b-card no-body>
        <b-tabs card fill>
          <b-tab :title="current_month_name" active>
             <b-card-text v-if="loading_this_month == true">
              <h3 class="text-center">
                Loading
                <br />
                <i class="fa fa-spinner fa-spin"></i>
              </h3>
            </b-card-text>
            <b-card-text v-if="loading_this_month == false">
              <h6 class="tw-font-bolder tw-mb-0 text-center">Light Traps - CORE</h6>
              <p class="text-secondary tw-text-xs text-center">Compounds Scheduled This Month</p>
              <h1
                class="tw-text-5l tw-font-bolder text-center tw-mb-0"
              >{{ lt_core_current_selected.length }} / {{ lt_core_target }}</h1>
                <span v-if="lt_core_current.length == 0" class="font-italic tw-text-s"><br />No light traps have been scheduled yet.</span>
                <div v-if="lt_core_current.length > 0" style="overflow-x: hidden;">
                  <br />
                  <b-row>
                  <b-col style="padding-top: 15px; text-align: right;">
                    Select Cluster:
                  </b-col>
                  <b-col>
                     <b-form-select v-model="lt_this_month" :options="lt_core_clusters" @change="update_lt_this_month" style="width: 75px;"></b-form-select>
                  </b-col>
                  </b-row>
                  <b-table striped hover :items="lt_core_current_selected" :fields="fields" style="max-height: 400px !important; overflow: auto; overflow-x: hidden;">
                    <template v-slot:cell(enrollment_status)="data">
                      <i class="fa fa-clock" style="color: #6c757d;" v-if="data.item.enrollment_status == 'pending'" title="Light Trap Placement Pending"></i>
                      <i class="fa fa-lightbulb text-warning" v-if="data.item.enrollment_status == 'light trap placed'" title="Light Trap Placed"></i>
                      <i class="fa fa-check text-success" v-if="data.item.enrollment_status == 'collected'" title="Light Trap Collected"></i>
                      <i class="fa fa-user-times text-danger" v-if="data.item.enrollment_status == 'omitted'" title="Omitted By Subject Enrollment"></i>
                    </template>
                  </b-table>
                </div>
            </b-card-text>
          </b-tab>
          <b-tab :title="next_month_name">
            <b-card-text v-if="loading_next_month == true">
              <h3 class="text-center">
                Loading
                <br />
                <i class="fa fa-spinner fa-spin"></i>
              </h3>
            </b-card-text>
            <b-card-text v-if="loading_next_month == false">
              <h6 class="tw-font-bolder tw-mb-0 text-center">Light Traps - CORE</h6>
              <p class="text-secondary tw-text-xs text-center">Compounds Scheduled Next Month</p>
              <h1
                class="tw-text-5l tw-font-bolder text-center tw-mb-0"
              >{{ lt_core_next_selected.length }} / {{ lt_core_target }}</h1>
                <span v-if="lt_core_next.length == 0" class="font-italic tw-text-s"><br />No light traps have been scheduled yet.</span>
                <div v-if="lt_core_next.length > 0" style="overflow-x: hidden;">
                  <br />
                  <b-row>
                  <b-col style="padding-top: 15px; text-align: right;">
                    Select Cluster:
                  </b-col>
                  <b-col>
                     <b-form-select v-model="lt_next_month" :options="lt_core_clusters" @change="update_lt_next_month" style="width: 75px;"></b-form-select>
                  </b-col>
                  </b-row>
                  <b-table striped hover :items="lt_core_next_selected" :fields="next_fields" style="max-height: 400px !important; overflow: auto; overflow-x: hidden;">
                  </b-table>
                </div>
            </b-card-text>
          </b-tab>
        </b-tabs>
      </b-card>

    <!-- <b-card header-tag="nav">
      <template v-slot:header>
        <b-nav card-header tabs fill>
          <b-nav-item active data-toggle="tab" role="tab" href="#today">Today</b-nav-item>
          <b-nav-item data-toggle="tab" role="tab" href="#total">Total</b-nav-item>
        </b-nav>
      </template>
      <b-card-text id="today">
        
      </b-card-text>
      <b-card-text id="total">
        <h6 class="tw-font-bolder tw-mb-0 text-center">Number of Subjects Referred</h6>
        <p class="text-secondary tw-text-xs text-center">Since beginning of study</p>
        <h1
          class="tw-text-5xl tw-font-bolder text-center tw-mb-0"
        >{{ total }}</h1>
      </b-card-text>
    </b-card> -->
  </div>
</template>

<script>
import { HTTP } from "@/utilities/http-common";
import HandleErrors from "@/utilities/handle-errors";
import * as moment from 'moment';

// import {
//     mapState, mapGetters, mapActions
// } from 'vuex';

export default {
  mixins: [],
  data: function(){
            return {
              fields: [
                { key: 'order' },
                { key: 'actual_compound_id', label: 'Compound', class: 'text-right' },
                { key: 'enrollment_status', label: 'Status', class: 'text-right'}
              ],
              next_fields: [
                { key: 'order' },
                { key: 'actual_compound_id', label: 'Compound', class: 'text-right' }
              ],
              current_month_name: moment().startOf("month").format('MMMM').toUpperCase(),
              next_month_name: moment().add(1, "month").startOf("month").format('MMMM').toUpperCase(),
              lt_core_current: [],
              lt_core_current_selected: [],
              lt_core_next_selected: [],
              lt_core_target: 10,
              lt_core_next: [],
              lt_core_clusters: [],
              lt_this_month: null,
              lt_next_month: null,
              next_month_set: true,
              loading_this_month: true,
              loading_next_month: true
            }
        },
  computed: {
    // ...mapState('sample', ['sample'])
  },
  created: function() {},
  mounted: function() {
    this.get();
  },
  methods: {
    update_lt_this_month: function(item){
      this.lt_core_current_selected = [];

      for(var i = 0; i < this.lt_core_current.length; i++){
        if(this.lt_core_current[i].cluster == item){
          this.lt_core_current_selected.push(this.lt_core_current[i]);
        }
      }
    },
    update_lt_next_month: function(item){
      this.lt_core_next_selected = [];

      for(var i = 0; i < this.lt_core_next.length; i++){
        if(this.lt_core_next[i].cluster == item){
          this.lt_core_next_selected.push(this.lt_core_next[i]);
        }
      }
    },
    get: function() {
      let that = this;
      HTTP.get("/kenya/lighttraps/get_this_month").then(response => {
        for(var i = 0; i < response.data.length; i++){
          if(response.data[i].core_or_buffer == 'core'){
            var data_item = response.data[i].cluster;
            if(this.lt_core_clusters.indexOf(data_item) < 0 ){
              this.lt_core_clusters.push(data_item);
            }
            this.lt_core_current.push(response.data[i]);
          }
        }

        if(this.lt_core_clusters.length > 0){
          this.lt_this_month = this.lt_core_clusters[0];
        }

        this.update_lt_this_month(this.lt_this_month);
        this.loading_this_month = false;
      });

       HTTP.get("/kenya/lighttraps/get_next_month").then(response => {
        for(var i = 0; i < response.data.length; i++){
          if(response.data[i].core_or_buffer == 'core'){
            var data_item = response.data[i].cluster;
            if(this.lt_core_clusters.indexOf(data_item) < 0 ){
              this.lt_core_clusters.push(data_item);
            }
            this.lt_core_next.push(response.data[i]);

            if(response.data[i].committed_to_commcare == false){
              this.next_month_set = false;
            }
          }

          if(this.lt_core_clusters.length > 0){
            this.lt_next_month = this.lt_core_clusters[0];
          }
        }
        this.update_lt_next_month(this.lt_next_month);
        this.loading_next_month = false;
      });
    },
    find: function() {},
    create: function() {},
    patch: function() {},
    update: function() {},
    delete: function() {}
  }
};
</script>

<style>
nav.card-header {
  border-bottom: none;
  padding: 0.5rem 0 0 0;
}
ul.nav.nav-tabs {
  padding: 0 0.5rem;
}
ul.nav.nav-tabs li.nav-item {
  font-size: 0.7rem;
}
ul.nav.nav-tabs a.nav-link {
  padding: 0.35rem 0.5rem;
}
</style>